/* RANI CUSTOM — PDP Taksit Seçenekleri (talep 9.3)
   "Taksit Seçenekleri" rozeti modal'ı açılınca CraftGate API'sinden tablo çekip basar.
   Fiyat = window.raniProductPrice (TL, integer) — main-product.liquid inline set eder.
   Variant değişiminde flag reset olur → modal sonraki açılışta güncel fiyatla yeniden çeker. */
(function () {
  if (typeof window === 'undefined') return;
  var loaded = false;
  var lastPrice = null;
  var inFlight = false;

  function getPrice() {
    if (typeof window.raniProductPrice === 'number' && window.raniProductPrice > 0) {
      return Math.round(window.raniProductPrice);
    }
    return null;
  }

  function findContainer() {
    var modal = document.getElementById('rani-modal-taksit');
    return modal ? modal.querySelector('.rani-taksit-content') : null;
  }

  function fetchAndRender(container, price) {
    if (inFlight) return;
    inFlight = true;
    container.innerHTML = '<p class="rani-taksit-loading">Taksit seçenekleri yükleniyor...</p>';
    container.classList.remove('rani-taksit-error');

    var url = 'https://entegrasyon.rani.com.tr/api/craftgate/installments?tutar=' + encodeURIComponent(price);
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        container.innerHTML = html;
        container.classList.remove('rani-taksit-error');
        /* RANI: kullanılamayan taksit satırlarını ("-") gizle */
        container.querySelectorAll('.taksitSecenekleriAna').forEach(function (row) {
          var t = row.querySelector('.taksitTutari');
          if (t && t.textContent.trim() === '-') row.remove();
        });
      })
      .catch(function () {
        container.innerHTML = '<p class="rani-taksit-error">Taksit seçenekleri şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.</p>';
      })
      .finally(function () { inFlight = false; });
  }

  function ensureLoaded() {
    var container = findContainer();
    if (!container) return;
    var price = getPrice();
    if (!price) return;

    if (loaded && lastPrice === price) return;
    lastPrice = price;
    loaded = true;
    fetchAndRender(container, price);
  }

  // Taksit rozetine tıklanınca modal açılır → API'yi çağır
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-rani-modal-open="rani-modal-taksit"]');
    if (!trigger) return;
    // Modal'ın açılma anına nano bir gecikme ver, sonra fetch
    setTimeout(ensureLoaded, 0);
  });

  // Variant değişiminde flag reset → modal sonraki açılışta yeni fiyatla yeniden fetch
  function onVariantChange(e) {
    var v = e && e.detail && (e.detail.variant || e.detail);
    if (v && typeof v.price === 'number') {
      window.raniProductPrice = v.price / 100;
      loaded = false;
      lastPrice = null;
    }
  }
  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('on:variant:change', onVariantChange);
})();
